import { AddOnOrderProps } from '../AddOnOrder';

const ContentAddOn = ({ orderData, setOrderData }: AddOnOrderProps) => {
  const handleContentManagement = () => {
    setOrderData({
      ...orderData,
      contentManagement: !orderData.contentManagement,
    });
  };

  return (
    <div>
      <p className="mt-8 text-base font-semibold text-primary-black">
        Let us manage your content. Just send it our way.
      </p>

      <div className="mt-4 flex items-start rounded-xl border border-[#CFD8E2] p-5">
        <input
          type="checkbox"
          className="h-[18px] w-[18px] checked:bg-black"
          onChange={handleContentManagement}
          checked={orderData.contentManagement}
        />
        <div className="ml-3">
          <p className="text-sm font-semibold text-primary-black lg:text-base">
            1 Year Content Management
          </p>
          <p className="mt-1.5 text-xs lg:text-sm">
            Whenever you have new text or images that you want to change or add
            to your website, send it our way and we will update it for you.
            Unlimited updates for the year, renewable annually.
          </p>
          <div className="my-3 border-b border-[#E3E8ED]" />
          <p className="text-sm font-bold text-primary-black lg:text-base">₣900</p>
        </div>
      </div>
    </div>
  );
};

export default ContentAddOn;
